var render = function render(_c,_vm){return _c('div',{class:_vm.$style.item},[_c('div',{class:_vm.$style.circle}),_c('div',{class:_vm.$style.wrap},[_c('h3',[_vm._v(_vm._s(_vm.props.action))]),_c('span',[_c('span',{class:_vm.$style.updated},[_vm._v(_vm._s(_vm.parent.$t('UPDATED')))]),_vm._v(" "+_vm._s(_vm.props.date)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }